import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Text } from "@chakra-ui/react";
import { useDiagnosticSignOut } from "~/hooks/useDiagnosticSignOut";

export const DiagnosticsSignOut: FC = () => {
  const { t } = useTranslation();
  const { handleSignOut } = useDiagnosticSignOut();

  return (
    <Box pb={4}>
      <Text
        as="button"
        onClick={handleSignOut}
        color="fg-main"
        fontWeight="medium"
        fontSize="sm"
        _hover={{ color: "gray.700" }}
        transition="colors 0.2s"
        position="absolute"
        right={6}
      >
        {t("diagnosticDashboard.signOut.buttonText")}
      </Text>
    </Box>
  );
};
